var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Message/Error") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 120 0 120 118.1387 0 118.1387"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Message/Error",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4561,69.3493 C63.4561,71.1753 61.9711,72.6603 60.1441,72.6603 L59.8551,72.6603 C58.0291,72.6603 56.5441,71.1753 56.5441,69.3493 L56.5441,52.3753 C56.5441,50.5493 58.0291,49.0643 59.8551,49.0643 L60.1441,49.0643 C61.9711,49.0643 63.4561,50.5493 63.4561,52.3753 L63.4561,69.3493 Z M60.1441,44.0643 L59.8551,44.0643 C55.2721,44.0643 51.5441,47.7923 51.5441,52.3753 L51.5441,69.3493 C51.5441,73.9323 55.2721,77.6603 59.8551,77.6603 L60.1441,77.6603 C64.7271,77.6603 68.4561,73.9323 68.4561,69.3493 L68.4561,52.3753 C68.4561,47.7923 64.7271,44.0643 60.1441,44.0643 L60.1441,44.0643 Z",
    id: "Fill-1",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4561,90.3598 C63.4561,92.1858 61.9711,93.6718 60.1441,93.6718 L59.8551,93.6718 C58.0291,93.6718 56.5441,92.1858 56.5441,90.3598 L56.5441,90.0708 C56.5441,88.2448 58.0291,86.7588 59.8551,86.7588 L60.1441,86.7588 C61.9711,86.7588 63.4561,88.2448 63.4561,90.0708 L63.4561,90.3598 Z M60.1441,81.7588 L59.8551,81.7588 C55.2721,81.7588 51.5441,85.4878 51.5441,90.0708 L51.5441,90.3598 C51.5441,94.9428 55.2721,98.6718 59.8551,98.6718 L60.1441,98.6718 C64.7271,98.6718 68.4561,94.9428 68.4561,90.3598 L68.4561,90.0708 C68.4561,85.4878 64.7271,81.7588 60.1441,81.7588 L60.1441,81.7588 Z",
    id: "Fill-3",
    fill: "#FF7900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1832,4.9997 C58.5992,4.9997 57.2222,5.8437 56.5002,7.2577 L5.4612,107.1687 C4.7932,108.4757 4.8482,109.9417 5.6132,111.1887 C6.3732,112.4277 7.6452,113.1387 9.1022,113.1387 L9.1092,113.1387 L110.8622,112.9727 C112.3302,112.9707 113.6142,112.2497 114.3822,110.9937 C115.1482,109.7437 115.2072,108.2797 114.5462,106.9787 L63.8322,7.2347 C63.1212,5.8367 61.7592,4.9997 60.1882,4.9997 L60.1832,4.9997 Z M9.1022,118.1387 C5.9132,118.1387 3.0162,116.5187 1.3502,113.8017 C-0.3208,111.0767 -0.4488,107.7457 1.0082,104.8927 L52.0472,4.9827 C53.6182,1.9087 56.7352,-0.0003 60.1842,-0.0003 L60.1932,-0.0003 C63.6302,0.0027 66.7322,1.9077 68.2892,4.9687 L119.0032,104.7137 C120.4492,107.5547 120.3152,110.8797 118.6472,113.6047 C116.9752,116.3357 114.0682,117.9677 110.8702,117.9727 L9.1172,118.1387 L9.1022,118.1387 Z",
    id: "Fill-5",
    fill: "#000000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bfe1bfa56f57b4abad057fdae62bfaee.svg";
export { ForwardRef as ReactComponent };